module.exports = __webpack_public_path__ + "static/media/ogs3.png.b38c4264.jpg";